import React, { useState, useMemo } from "react";
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register chart.js components
ChartJS.register(
  BarController,
  LineController,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const baseData = {
  labels: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", ],
  datasets: [
    {
      type: "line",
      label: "Stock Trend",
      data: [5000, 5500, 6000, 6000, 5800, 8000,],
      borderColor: "#FFBD26",
      borderWidth: 11,
      pointRadius: 0,
      fill: false,
      tension: 0,
      order: 0,
      yAxisID: "y",
    },
    {
      type: "bar",
      label: "Expenses",
      data: [6000, 7000, 7400, 7400, 8300, 8000],
      backgroundColor: Array(8).fill("#152C24"),
      borderRadius: { topLeft: 10, topRight: 10 },
      borderSkipped: false,
      order: 1,
      yAxisID: "y",
barPercentage:  0.9,         // reduce bar width a little (optional)
categoryPercentage: 0.9,    // increase to reduce group spacing

    },
    {
      type: "bar",
      label: "Revenue",
      data: [5000, 7000, 7800, 8200, 8700, 8000, ],
      backgroundColor: Array(8).fill("#2E453D"),
      borderRadius: { topLeft: 10, topRight: 10 },
      borderSkipped: false,
      order: 2,
      yAxisID: "y",
barPercentage: 0.9,         // reduce bar width a little (optional)
categoryPercentage: 0.9,    // increase to reduce group spacing

    },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { mode: "index", intersect: false },
  },
  scales: {
    y: {
      min: 1000,
      max: 10000,
      grid: { display: false },
      position: "left",
      ticks: {
        stepSize: 1000,
        font: { size: 30, weight: "semibold" },
            padding: 50, // ← Move numbers to the right (increase this)
        color: "#000",
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    yRight: {
      min: 1000,
      max: 10000,
      position: "right",
      grid: { drawOnChartArea: false },
      ticks: {
        stepSize: 1000,
        font: { size: 30, weight: "semibold" },
        color: "#000",
        padding: 50, 
        callback: (value) => (value === 0 ? "" : value),
      },
      offset: true,
    },
    x: {
      grid: { display: false },
      ticks: {
        font: { size: 28, weight: "bold" },
        color: "#000",
        
      },
    },
  },
  layout: {
    padding: { top: 20, bottom: 40 },
  },
};

const ChartComponent = () => {
  const [hoveredColor, setHoveredColor] = useState(null);

  const filteredData = useMemo(() => {
    return {
      ...baseData,
      datasets: baseData.datasets.map((dataset) => {
        if (dataset.type === "line") return dataset;

        return {
          ...dataset,
          backgroundColor: dataset.backgroundColor.map((color) =>
            !hoveredColor || color === hoveredColor
              ? color
              : "rgba(0,0,0,0.05)"
          ),
        };
      }),
    };
  }, [hoveredColor]);

  return (
    <div className="relative md:-mt-16  w-full h-[600px] mb-44 ">
 
      <div className="w-full h-[110%] z-10 ">
      
        <Chart type="bar" data={filteredData} options={options} />
      </div>

      {/* Color filter boxes */}
      <div className="absolute bottom-[-100px] right-0 w-[85%] grid grid-cols-3 gap-4 ">
        {/* Expenses */}
        
        <div className="flex flex-col gap-2">
    
          <div className="flex items-center space-x-3">
            <div
              className="w-[42px] h-[42px] bg-[#FFBD26] cursor-pointer"
              onMouseEnter={() => setHoveredColor("#FFBD26")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Expense"
            />
            <h1 className="text-[24px] font-bold text-[#152C24]">Number of Farmers</h1>
          </div>
        </div>

        {/* Revenue */}
        <div className="flex flex-col gap-2">
        
          <div className="flex items-center space-x-3">
            <div
              className="w-[42px] h-[42px] bg-[#2E453D] cursor-pointer"
              onMouseEnter={() => setHoveredColor("#2E453D")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Revenue"
            />
            <h1 className="text-[24px] font-bold text-[#2E453D]">Production </h1>
          </div>
        </div>
        <div className="flex flex-col gap-2">
    
          <div className="flex items-center space-x-3">
            <div
              className="w-[42px] h-[42px] bg-[#152C24] cursor-pointer"
              onMouseEnter={() => setHoveredColor("#152C24")}
              onMouseLeave={() => setHoveredColor(null)}
              title="Highlighted Expense"
            />
            <h1 className="text-[24px] font-bold text-[#152C24]">Inventory</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartComponent;
